/** This export is automatically generated */
export const gitHash = '8973f294';
